var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommand } from '@fortawesome/pro-regular-svg-icons/faCommand';
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { ClickText, Concat, ContentWrapper, DeleteWrapper, Description, HeaderContainer, IconGroup, IconText, IconWrapper, ModalContent, ShortCutTitle, ShortCutWrapper, customShortCutLBModalStyles, customShortCutModalStyles,
// customShortCutModalStyles,
 } from './styles';
import { selectLBShortCutModalState, selectShortCutModalState, } from 'store/structureBuilderUI/selectors';
import { closeShortCutModal } from 'store/structureBuilderUI/actions';
import { useCloseOnRouteChange } from 'utils/hooks/closeOnRouteChange';
/**
 * Register Modal to the app root
 */
Modal.setAppElement('#app');
export var ShortCutModal = function (_a) {
    var onClose = _a.onClose, isLB = _a.isLB;
    var dispatch = useDispatch();
    var isModalOpen = useSelector(selectShortCutModalState);
    var isLBModalOpen = useSelector(selectLBShortCutModalState);
    var handleOnCloseModal = useCallback(function () {
        dispatch(closeShortCutModal);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }, [dispatch, onClose]);
    // The builder pages never unmount on navigation, so this portal-rendered
    // modal stays open above whatever page the user navigates to unless we
    // close it explicitly on route change.
    useCloseOnRouteChange(isLB ? isLBModalOpen : isModalOpen, handleOnCloseModal);
    var detectOS = function () {
        var userAgent = window.navigator.userAgent;
        if (userAgent.indexOf('Mac') != -1) {
            return (_jsx(IconWrapper, { children: _jsx(FontAwesomeIcon, { color: '#828282', size: '1x', icon: faCommand }) }));
        }
        else {
            return _jsx(IconText, { children: "Ctrl" });
        }
    };
    var detectOSWithoutWrapper = function () {
        var userAgent = window.navigator.userAgent;
        if (userAgent.indexOf('Mac') != -1) {
            return _jsx(FontAwesomeIcon, { color: '#828282', size: '1x', icon: faCommand });
        }
        else {
            return _jsx(IconText, { children: "Ctrl" });
        }
    };
    return (_jsx(Modal, __assign({ isOpen: isLB ? isLBModalOpen : isModalOpen, onRequestClose: handleOnCloseModal, contentLabel: "Shortcut key Modal", style: isLB ? customShortCutLBModalStyles() : customShortCutModalStyles(), shouldCloseOnEsc: true, shouldCloseOnOverlayClick: true }, { children: _jsxs(ModalContent, { children: [_jsxs(HeaderContainer, { children: [_jsx(ShortCutTitle, { children: "Keyboard Shortcuts" }), _jsx(DeleteWrapper, __assign({ onClick: function () {
                                handleOnCloseModal();
                            } }, { children: _jsx(FontAwesomeIcon, { color: '#828282', size: "1x", icon: faTimes }) }))] }), _jsxs(ContentWrapper, { children: [_jsxs(ShortCutWrapper, { children: [_jsx(Description, { children: "Copy a patch" }), _jsxs(IconGroup, { children: [detectOS(), _jsx(Concat, { children: "+" }), _jsx(IconText, { children: "C" })] })] }), _jsxs(ShortCutWrapper, { children: [_jsx(Description, { children: "Paste a patch" }), _jsxs(IconGroup, { children: [detectOS(), _jsx(Concat, { children: "+" }), _jsx(IconText, { children: "V" })] })] }), _jsxs(ShortCutWrapper, { children: [_jsx(Description, { children: "Delete a patch / edge" }), _jsx(IconGroup, { children: _jsx(IconText, { children: "Delete" }) })] }), _jsxs(ShortCutWrapper, { children: [_jsx(Description, { children: "Locate a patch" }), _jsxs(IconGroup, { children: [detectOS(), _jsx(Concat, { children: "+" }), _jsx(IconText, { children: "F" })] })] }), _jsxs(ShortCutWrapper, { children: [_jsx(Description, { children: "Multi selection" }), _jsxs(IconGroup, { children: [_jsxs(IconText, { children: ["Shift / ", detectOSWithoutWrapper()] }), _jsx(Concat, { children: "+" }), _jsx(ClickText, { children: "Click" })] })] }), _jsxs(ShortCutWrapper, { children: [_jsx(Description, { children: "Close modal or context menu" }), _jsx(IconGroup, { children: _jsx(IconText, { children: "esc" }) })] })] })] }) })));
};
